import { Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { combineUrlAndParams } from "@nens/shared-utils";

import { RanaLink } from "@/components/rana-link";
import { FROM_PUBLICATION_KEY, PUBLICATION_SEARCH_KEY } from "@/config/query-parameter-consts";

interface PublicationPublicGoToNormalViewerButtonProps {
  rightIcon?: React.ReactNode;
  projectSlug: string;
  publicationId: string;
}

export function PublicationPublicGoToNormalViewerButton({
  rightIcon,
  projectSlug,
  publicationId,
}: PublicationPublicGoToNormalViewerButtonProps) {
  // Tenant code is first path of current URL
  const tenant = window.location.pathname.split("/")[1];

  const to = combineUrlAndParams(`/${tenant}/projects/${projectSlug}`, {
    tab: 3,
    [PUBLICATION_SEARCH_KEY]: publicationId,
    [FROM_PUBLICATION_KEY]: "true",
  });

  return (
    <Flex>
      Or
      <RanaLink ml={1} textDecoration="underline" to={to}>
        <FormattedMessage
          id="publication.open_with_rana_account"
          defaultMessage="open with Rana account"
        />
        {rightIcon}
      </RanaLink>
    </Flex>
  );
}
